import { Link } from '@/global/components/Link'
import Grid from '@/global/components/ui/Grid'
import { FormField } from 'global/components/Form'
import { SelectColaboradores } from './SelectColaboradores'
import { SelectFunction } from './SelectFuncoes'
import { SelectSegmento } from './SelectSegmento'

export function FormAvaliacao() {
    return (
        <Grid container>
            <Grid item xs={12} sm={6}>
                <FormField
                    name="nomeResponsavel"
                    label="Nome completo"
                    required
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <FormField
                    name="nomeFantasia"
                    label="Nome da empresa"
                    required
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <FormField
                    name="cnpj"
                    label={
                        <>
                            Documento{' '}
                            <span className="text-xs text-muted-foreground">
                                (CPF/CNPJ/CAEPF)
                            </span>
                        </>
                    }
                    required
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <SelectSegmento required />
            </Grid>

            <Grid item xs={12} sm={6}>
                <FormField
                    name="emailResponsavel"
                    label="Email para login"
                    required
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <FormField
                    name="telefone"
                    label="Telefone para contato (com DDD)"
                    type="tel"
                    required
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <FormField
                    name="senha"
                    label="Senha"
                    type="password"
                    required
                    autoComplete="new-password"
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <FormField
                    name="confirme"
                    label="Confirme sua senha"
                    type="password"
                    required
                    autoComplete="new-password"
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <SelectFunction required />
            </Grid>

            <Grid item xs={12} sm={6}>
                <SelectColaboradores required />
            </Grid>

            <Grid item xs={12}>
                <span className="text-xs text-muted-foreground">
                    Ao iniciar o teste grátis, você está concordando com os{' '}
                    <Link href="/termos" target="_blank">
                        Termos de Uso
                    </Link>{' '}
                    e{' '}
                    <Link href="/politicas" target="_blank">
                        Política de Privacidade
                    </Link>
                    .
                </span>
            </Grid>
        </Grid>
    )
}
